
import React, { useState } from 'react';
import '../components/FinancialsPage.css';
import { useAuth } from '../context/AuthContext';

function FinancialsPage() {
    const { user, projects } = useAuth();
    const [selectedProjectId, setSelectedProjectId] = useState('');
    const [fileName, setFileName] = useState('');

    const handleFileChange = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        setFileName(file.name);

        //Future send to backend for processing
    }

    const handleQuickUpload = () => {
        if (!selectedProjectId || !fileName) {
            alert ("Please select a project and upload a file.");
            return;
        }

        //Call backend functon to process receipt/etc
    };

    return (
        <div className="financials-page">
            <h1 className="financials-title">Financials Dashboard</h1>

            <div className="financials-summary-row">
                <SummaryCard 
                title="Total Expenses This Month"
                value="$12,450"
                />
                <SummaryCard 
                    title="Pending Receipts"
                    value="8"
                />
                <SummaryCard 
                title="Approved Expenses"
                value="$9,300"
                />
            </div>

            <div className = "financials-main-row">
                <div className = "financials-projects">
                    <h2 className = "section-title"> Browse by Project</h2>

                    <div className = "project-card-grid">
                        {projects && projects.length > 0 ? (
                            projects.map((project) => (
                                <ProjectFinancialCard
                                    key={project.id}
                                    project={project}
                                />
                            ))
                        ) : (
                            <p className = "empty-state">
                                You don't have any projects yet. Create a project to start tracking financials.
                            </p>
                        )}
                    </div>
                </div>
                <QuickUploadPanel
                    projects={projects}
                    selectedProjectId={selectedProjectId}
                    onSelectProject={setSelectedProjectId}
                    fileName={fileName}
                    onFileChange={handleFileChange}
                    onUpload={handleQuickUpload}
                />
            </div>
        </div>
    );
}

function SummaryCard ({ title, value }) {
    return (
        <div className="summary-card">
            <div className="summary-title">{title}</div>
            <div className="summary-value">{value}</div>
        </div>
    );
}

function ProjectFinancialCard({ project }) {

    const Budget = "$50,000"; //Placeholder 
    const Expenses = "$18,750"; //Placeholder
    const Remaining = "$31,250"; //Placeholder

    return (
        <div className = "project-financial-card">
            <div className = "project-financial-text">
                <div className = "project-name">{project.name || project.address}</div>
                <div className = "project-location"> {project.address}</div>
                <div className = "project-budget-row">
                    <span className = "project-budget-label"> Budget: </span>
                    <span className = "project-budget-value"> {Budget} </span>
                </div>
                <div className= "project-expenses-row">
                    <span className = "project-expenses-label"> Expenses: </span>
                    <span className = "project-expenses-value"> {Expenses} </span>
                </div>
                <div className= "project-remaining-row">
                    <span className = "project-remaining-label"> Remaining: </span>
                    <span className = "project-remaining-value"> {Remaining} </span>
                </div>
            </div>

            <div className="project-financial-actions">
                <button className="view-details-btn"> View Details </button>
            </div>
        </div>
    );
}
           
function QuickUploadPanel ({
    projects,
    selectedProjectId,
    onSelectProject,
    fileName,
    onFileChange,
    onUpload
}) {
    return (
        <div className="quick-upload-panel">
            <h2 className="section-title">Quick Upload</h2>

            <div className="upload-dropzone">
                <p className = "dropzone-icon">📄</p>
                <p className = "dropzone-text">
                    Drag &amp; drop receipt or invoice here<br />
                    or click to browse files
                </p>
                <label className = "choose-file-btn">
                    Choose File
                    <input
                        type="file"
                        accept="image/*,application/pdf"
                        onChange={onFileChange}
                        style={{ display: 'none' }}
                    />
                </label>
                {fileName && (
                    <p className="chosen-file-label">
                        Selected File: <span>{fileName}</span>
                    </p>
                )}
            </div>

            <div className="upload-fields">
                <label className = "field-label">Project</label>
                <select
                    className="project-select"
                    value={selectedProjectId}
                    onChange={(e) => onSelectProject(e.target.value)}
                >
                    <option value="">Select a project</option>
                    {projects && projects.map((p) => (
                        <option key={p.id} value={p.id}>
                            {p.name || p.address}
                        </option>
                    ))}
                </select>
            </div>

            <button className="upload-submit-btn" onClick={onUpload}>
                View &amp; Attach
            </button>
        </div>
    );
}

export default FinancialsPage;
    

